import { TGoogleRoutePoint } from "../../../api/types/Map";
import {
  getGoogleRoutePointsFromTripPoints,
  renderRouteWithPolylines,
} from "./helper";
import { RenderRoute } from "./renderRoute.class";

export class RenderRoutePointToPoint extends RenderRoute {
  render = () => {
    const { props, tripIndex, sanitizedTripPoints, polylineConfig } = this;
    const map = this.props.mapRef.current.map;
    const routeVisibility =
      props.mapRef.current.routeViewsEnabled.POINT_TO_POINT;

    const gRoutePoints: TGoogleRoutePoint[] =
      getGoogleRoutePointsFromTripPoints({ tripPoints: sanitizedTripPoints });

    // render the route
    if (
      props?.selectedTripIndex !== null &&
      tripIndex !== props?.selectedTripIndex
    ) {
      // do nothing
    } else {
      // renderRouteWithPolylines();
      const mapElements = renderRouteWithPolylines({
        props,
        tripIndex,
        polylineConfig,
        gRoutePoints,
        routeVisibility,
      });
      this.setMapElements(mapElements);
    }

    // set route visibility in mapRef
    // 1 for visible, 0 for hidden. Initially setting the visibility based on routeViewsEnabled,
    // and then it can be toggled using show/hide methods of the class which will also update this visibility value accordingly
    props.mapRef.current.objects.mTripsVisibility.push(routeVisibility ? 1 : 0);

    this.isInitialized = true; // set initialized flag to true after first render
  };
}
